export class AnswerManager {
    constructor() {
        this.answers = [];
    }

    initializeAnswers(questions) {
        this.answers = [];
        questions.forEach((question) => {
            const q = question.properties;
            if (q.type !== 'Engagement Trigger' && q.type !== 'Thank You Message') {
                this.answers.push({
                    questionId: q.id,
                    type: q.type,
                    question: q.content,
                    answer: '',
                    viewed: false,
                    isObligated: q.isObligated,
                    isLogicSkipped: false,
                });
            }
        });
        return this.answers;
    }

    updateAnswer(question, answer) {
        let item = {
            questionId: question.id,
            type: question.type,
            question: question.content,
            answer: answer,
            viewed: true,
            isObligated: question.isObligated,
            isLogicSkipped: true,
        };
        this.answers[question.index - 1] = item;
    }

    updateViewedStatus(questionId) {
        let index = this.answers.findIndex((item) => item.questionId === questionId);
        if (index !== -1) {
            this.answers[index].viewed = true;
        }
    }

    updateSkippedStatus(questionId, questions) {
        if (!questionId) {
            for (let i = 0; i < this.answers.length; i++) {
                if (this.answers[i]) this.answers[i].isLogicSkipped = true;
            }
            return;
        }

        let isThankYouMessage =
            questions.find((q) => q.properties?.id === questionId)?.properties?.type === 'Thank You Message';

        if (isThankYouMessage) {
            for (let i = 0; i < this.answers.length; i++) {
                if (this.answers[i]) this.answers[i].isLogicSkipped = true;
            }
            return;
        }

        let answerIndex = this.answers.findIndex((item) => item?.questionId === questionId);
        for (let i = 0; i < answerIndex; i++) {
            if (this.answers[i]) this.answers[i].isLogicSkipped = true;
        }
    }

    checkHasEmptyAnswers() {
        return this.answers.some((answer) => {
            if (
                (answer.isObligated === '0' || answer.isObligated === false) ||
                (answer.isLogicSkipped === true || answer.isLogicSkipped === '1')
            ) {
                return false;
            }
            if (Array.isArray(answer.answer)) {
                return answer.answer.length === 0;
            }
            return answer.answer === '' || answer.answer === null || answer.answer === undefined;
        });
    }

    checkHasAtLeastOneAnswer() {
        return this.answers.some((answer) => {
            if (Array.isArray(answer.answer)) {
                return answer.answer.length > 0;
            }
            return answer.answer !== '' && answer.answer !== null && answer.answer !== undefined;
        });
    }

    getAnswersLength(questions) {
        let answersLength = 0;
        questions.forEach((question) => {
            const type = question.properties ? question.properties.type : question.type;
            if (type !== 'Engagement Trigger' && type !== 'Thank You Message') {
                answersLength++;
            }
        });
        return answersLength;
    }
}
